import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Breadcrumb } from "antd";

class Breadcrumbs extends Component {
  render() {
    const itemsLength = this.props.breadcrumbItems.length;

    const items = this.props.breadcrumbItems.map((item, key) =>
      key + 1 === itemsLength
        ? { title: item.title }
        : {
            title: <Link to={item.link}>{item.title}</Link>,
          },
    );

    return (
      <React.Fragment>
        <Row>
          <Col xs={24}>
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0">{this.props.title}</h4>

              <div className="page-title-right">
                <Breadcrumb items={items} />
              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default Breadcrumbs;
